/** @jsx jsx */ /** @jsxRuntime classic */
import React from 'react';
import { jsx, Button, Box, Flex } from 'theme-ui';
import img from "./images/harvard-wics-logo.png";

const months = { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec", };

const SidePanel = ({ event, onClose }) => {
  if (!event) {
    return null; 
  }

  const textContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    fontFamily: 'Poppins',
  };

  const dateTimeContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    flex: 0.3,
  };

  const monthStyle = {
    fontSize: '1.1vw',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#6E4884',
    marginBottom: '2px',
  };

  const dayStyle = {
    fontSize: '2.1vw',
    color: 'black',
    fontWeight: 'bold',
  };

  const infoContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 0.7,
    paddingLeft: '10px',
    overflowWrap: 'anywhere',
  };

  const headingStyle = {
    fontSize: '1.7em',
    paddingTop: '30px',
    padding: '10px',
    color: 'black',
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const timeText = {
    fontSize: '1em',
    marginBottom: '3px',
    color: 'grey',
  };

  const locationLink = {
    fontSize: '1.1em',
    wordWrap: 'break-word',
    color: '#6E4884',
    textDecoration: 'none',
    overflowWrap: 'anywhere',
  };

  const descriptionStyle = {
    color: '#333',
    textAlign: 'left',
    padding: '10px',
    overflowWrap: 'anywhere',
  };

return (
  <Box
    sx={{
      position: 'fixed',
      cursor: 'auto',
      top: 0,
      right: 0,
      width: '20%',
      height: '100%',
      bg: 'background',
      overflowY: 'scroll',
      backgroundColor: '#FFFFFF',
      boxShadow: '-2px 0px 10px rgba(0, 0, 0, 0.1)',
      padding: 3,
      zIndex: 1000,
      transition: 'transform 0.3s ease',
    }}
  >
    <Button
      onClick={onClose}
      sx={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        padding: '5px 10px',
        backgroundColor: '#6E4884',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      x
    </Button>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h1 style={headingStyle}>{event.heading}</h1>
        <div style={textContainerStyle}>
        
          <div style={dateTimeContainer}>
            <h1 style={monthStyle}>{months[event.month]}</h1>
            <h1 style={dayStyle}>{event.day}</h1>
          </div>

          <div style={infoContainer}>
            <p style={timeText}>{`${event.startTime} - ${event.endTime}`}</p>
            <a style={locationLink}>{event.location && event.location.split(',')[0]}</a>
          </div>

        </div>

        <div style={descriptionStyle}>
          <p dangerouslySetInnerHTML={{ __html: event.description }}></p>
          <style>
            {`
              p a {
                text-decoration: underline;
                color: blue; /* keeps the same text color */
              }
            `}
          </style>
        </div>

    </div>

  </Box>
);
};

export default SidePanel;